export default __webpack_public_path__ + "static/media/bj.bf771f47.svg";